import { useEffect, useMemo } from "react";
import { useUserSettings } from "../../toolympus/components/Settings/UserSettingsContext";
import { createSelectSchema } from "../../toolympus/hooks/useSchema";
import { ProcessStatusDateCurrentKey, ProcessStatusDatePrevKey, StatusDateCurrentKey, statusDateLabel, StatusDatePrevKey } from "./useAppSettings";

export const createStatusDateSchema = (options: string[]) => {
  return createSelectSchema(options.map((d: string) => ({ value: d, label: statusDateLabel(d) })), { label: "Дата" });
}

export const useStatusDates = (mode: "project" | "process") => {
  const userSettings = useUserSettings();

  useEffect(() => {
    userSettings.ensureLoaded();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fieldSchema = useMemo(() => {
    return createStatusDateSchema([userSettings.global[StatusDateCurrentKey], userSettings.global[StatusDatePrevKey]].filter(x => !!x));
  }, [userSettings.global]);

  const current = mode === "process" ? userSettings.global[ProcessStatusDateCurrentKey] : userSettings.global[StatusDateCurrentKey];
  const prev = mode === "process" ? userSettings.global[ProcessStatusDatePrevKey] : userSettings.global[StatusDatePrevKey];

  return {
    dates: {
      current: {
        date: current,
        label: statusDateLabel(current),
      },
      prev: {
        date: prev,
        label: statusDateLabel(prev),
      },
    },
    fieldSchema,
  }
}
